



































import { Component, Vue } from "vue-property-decorator";
import { copyStyle } from "@/services/styles/stylesService";
import { CopyStyle } from "@/services/styles/types";

@Component
export default class StyleCopyModal extends Vue {
    model = {} as CopyStyle;
    name = "";

    open(id: string, name: string) {
        this.model.id = id;
        this.model.name = name + " Copy";
        this.name = name;
        this.$bvModal.show("modal-styleCopy");
    }

    confirm() {
        this.$bvModal.hide("modal-styleCopy");
        copyStyle(this.model).then(() => {
            this.$emit("reload");
        });
        this.model = {} as CopyStyle;
    }

    decline() {
        this.$bvModal.hide("modal-styleCopy");
    }
}
